// src/pages/ChatbotSettings/ChatbotTrainingInfo.js
import React from 'react';
import { Typography, Box, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import WebIcon from '@mui/icons-material/Web';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


// No onComplete prop needed here as parent's "Next" button handles it.
const ChatbotTrainingInfo = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
                Prepare to Train Your Chatbot
            </Typography>
            <Paper elevation={0} sx={{ p: 2, backgroundColor: 'action.hover', borderRadius: 1 }}>
                <Typography variant="body1" paragraph>
                    Your chatbot's foundation (name, avatar, language, initial prompt) is now set!
                    To make it truly knowledgeable and helpful, the next crucial phase is providing it with data to learn from.
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    You can use various data sources:
                </Typography>
                <List dense>
                    <ListItem>
                        <ListItemIcon><WebIcon color="primary" /></ListItemIcon>
                        <ListItemText primary="Website Content" secondary="Crawl public webpages or sitemaps to ingest text." />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><DescriptionIcon color="primary" /></ListItemIcon>
                        <ListItemText primary="Documents" secondary="Upload files like PDFs, DOCX, TXT, CSVs." />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><ImageIcon color="primary" /></ListItemIcon>
                        <ListItemText primary="Images" secondary="Provide images for visual context or information extraction (if supported)." />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><AudiotrackIcon color="primary" /></ListItemIcon>
                        <ListItemText primary="Audio Files" secondary="Transcribe audio recordings to text for training." />
                    </ListItem>
                </List>
                <Typography variant="body1" paragraph sx={{ mt: 2 }}>
                    After adding these data sources via the "Data Sources" section in your dashboard, you will be able to select them to train your chatbot.
                    This training process allows your chatbot to understand and respond to user queries based on the information you've provided.
                </Typography>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', mt:2, p:1, backgroundColor: 'success.light', borderRadius: 1}}>
                    <CheckCircleOutlineIcon color="success" sx={{mr: 1}}/>
                    <Typography variant="body2" color="success.dark" >
                        Click "Finish Setup & Add Data" below to proceed to add your first data source.
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
};

export default ChatbotTrainingInfo;